"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrofrontendApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const AppRoutes_1 = require("./AppRoutes");
const MicrofrontendApp = ({ initialPath = "/", onNavigate, navigateTo$, }) => {
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.MemoryRouter, { initialEntries: [initialPath], children: [(0, jsx_runtime_1.jsx)(NavigationSync, { onNavigate: onNavigate, "navigateTo$": navigateTo$ }), (0, jsx_runtime_1.jsx)(AppRoutes_1.AppRoutes, {})] }));
};
exports.MicrofrontendApp = MicrofrontendApp;
const NavigationSync = ({ onNavigate, navigateTo$ }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        if (onNavigate) {
            onNavigate(location.pathname);
        }
    }, [location, onNavigate]);
    (0, react_1.useEffect)(() => {
        if (navigateTo$) {
            const cb = (path) => {
                if (location.pathname !== path) {
                    navigate(path);
                }
            };
            navigateTo$.subscribe(cb);
            return () => {
                // Unsubscribe logic if your event bus supports it
            };
        }
    }, [navigateTo$, navigate, location.pathname]);
    return null;
};
